<template>
    <div>
        <!-- <div v-if="!showFullScreenMenu">
            <div class="top-menu">
                <button @click="showMenuIntroduction">餐馆介绍</button>
                <button @click="showFullScreenMenu = true">菜单</button>
                <button @click="showOnlineOrder">在线下单</button>
                <button @click="showReservation">预订座位</button>
            </div>
            <h1>菜单</h1>
            
        </div> -->
        <full-screen-menu v-if="showFullScreenMenu" @close="showFullScreenMenu = false" />
    </div>
  </template>
  
  <script>
  import FullScreenMenu from './FullScreenMenu.vue'; // 引入 FullScreenMenu 组件
  
  export default {
    name: 'MenuPage',
    components: {
      FullScreenMenu,
    },
    data() {
      return {
        showFullScreenMenu: false, // 控制全屏菜单的显示
        // ... 其他 data 属性 ...
      };
    },
    // ... 其他 methods ...
      methods: {
          showMenuIntroduction() {
              // 跳转到餐馆介绍页面
              this.$router.push('/menu-introduction');
          },
          showOnlineOrder() {
              // 跳转到在线下单页面
              this.$router.push('/online-order');
          },
          showReservation() {
              // 跳转到预订座位页面
              this.$router.push('/reservation');
          },
      }
  };
  </script>
  <style scoped>
  .top-menu{
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
  }
  </style>